import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { ISearchFacet, ISearchFacetItemQueryExpr } from '../../services/search.service';
import { AccordionComponent, IsgPanel, IsgPanelContent } from '../../../widgets/accordion/accordion.component';
import { FormsModule } from '@angular/forms';
import { RemoveCharacterPipe } from '../../../../modules/fwcore/pipes/remove-char.pipe';
import { CommonModule, NgFor } from '@angular/common';

@Component({
  selector: 'app-search-facets',
  standalone: true,
  imports: [AccordionComponent, RemoveCharacterPipe, IsgPanel, IsgPanelContent, FormsModule, CommonModule, NgFor],
 
  templateUrl: './search-facets.component.html',
  styleUrls: ['./search-facets.component.scss']
})
export class SearchFacetsComponent implements OnInit {
  expandMode: PanelBarExpandMode = PanelBarExpandMode.Default;
  @Input() facets?: ISearchFacet[] = [];
  @Input() selectedDocument: string = '';
  @Output() filter = new EventEmitter<ISearchFacetItemQueryExpr[]>();

  constructor(private _elementRef: ElementRef) { }

  ngOnInit(): void {
    const timeoutValue = setTimeout(() => {
      if (this.selectedDocument == 'CASE STUDIES') {
        (document.getElementById('sfi_chk_datasourcename_Case Studies') as HTMLElement).click();
        clearTimeout(timeoutValue);
      }
      else {
        clearTimeout(timeoutValue);
      }
    }, 8000);
  }

  public facetCheck(event: any) {
    let inputs = this._elementRef.nativeElement.querySelectorAll("input[id^='sfi_chk_']:checked");
    // Get list of checked facets and pass them in filter event
    var output: ISearchFacetItemQueryExpr[] = [];

    inputs.forEach((input: any) => {
      const parts = input.id.split('_');

      var fid = '';
      var html = '';

      if (parts.length == 4) {
        fid = parts[2];
        html = parts[3];
      }
      else if (parts.length == 5) {
        fid = parts[3];
        html = parts[4];
      }
      const selectedFacet = this.facets?.find(facet => facet.id.includes(fid));
      if (selectedFacet != null) {
        const selectedEntry = selectedFacet.entries.find(entry => entry.html == html);
        if (selectedEntry != null) {
          output.push(selectedEntry.queryExpr);
        }
      }
    });
    this.filter.emit(output);
  }
}
